module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-0 w-1200"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    staticClass: "form-pane",
    attrs: {
      "label": "票据类型",
      "name": "first"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型名称",
      "prop": "cost_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    model: {
      value: (_vm.form.cost_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "cost_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.cost_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "form-pane",
    attrs: {
      "label": "票据类型相关",
      "name": "second"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "config_list"
    }
  }, [_vm._l((_vm.form.config_list), function(item, index) {
    return _c('el-row', [_c('el-col', {
      key: index,
      staticStyle: {
        "margin-top": "15px",
        "margin-bottom": "15px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n                  " + _vm._s(index + 1) + "、配置名称："), _c('el-input', {
      staticClass: "h-40 w-200 m-r-30",
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    }), _vm._v("\n                  配置类型："), _c('el-select', {
      staticClass: "h-40 w-200 m-r-30",
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    }, [_c('el-option', {
      key: "1",
      attrs: {
        "label": "输入框",
        "value": 1
      }
    }), _vm._v(" "), _c('el-option', {
      key: "2",
      attrs: {
        "label": "选择框",
        "value": 2
      }
    }), _vm._v(" "), _c('el-option', {
      key: "3",
      attrs: {
        "label": "城市",
        "value": 3
      }
    }), _vm._v(" "), _c('el-option', {
      key: "4",
      attrs: {
        "label": "日期",
        "value": 4
      }
    })], 1), _vm._v("\n                  必填："), _c('el-checkbox', {
      model: {
        value: (item.is_must),
        callback: function($$v) {
          _vm.$set(item, "is_must", $$v)
        },
        expression: "item.is_must"
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "m-l-30",
      attrs: {
        "size": "small",
        "type": "danger",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.configDel(index, _vm.form.config_list)
        }
      }
    }, [_vm._v("删除配置")])], 1), _vm._v(" "), _vm._l((item.value_list), function(item1, index1) {
      return (item.type == 2 && item.value_list.length > 0) ? _c('el-col', {
        key: index1,
        staticStyle: {
          "margin-bottom": "15px",
          "margin-left": "42px"
        },
        attrs: {
          "span": 24
        }
      }, [_vm._v("\n                    选项" + _vm._s(index1 + 1) + "："), _c('el-input', {
        staticClass: "h-40 w-200",
        model: {
          value: (item1.value),
          callback: function($$v) {
            _vm.$set(item1, "value", $$v)
          },
          expression: "item1.value"
        }
      }), _vm._v(" "), _c('el-button', {
        staticClass: "m-l-30",
        attrs: {
          "size": "small",
          "type": "danger",
          "plain": ""
        },
        on: {
          "click": function($event) {
            return _vm.valueDel(index1, item.value_list)
          }
        }
      }, [_vm._v("删除选项")])], 1) : _vm._e()
    }), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-bottom": "15px"
      },
      attrs: {
        "span": 24
      }
    }, [(item.type == 2) ? _c('el-button', {
      staticClass: "m-l-50 m-t-50",
      attrs: {
        "size": "small",
        "type": "primary",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.valueAdd(item.value_list)
        }
      }
    }, [_vm._v("增加选项")]) : _vm._e()], 1)], 2)
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "m-l-50",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.configAdd(_vm.form.config_list)
      }
    }
  }, [_vm._v("增加配置")])], 1), _vm._v(" "), _c('p', [(_vm.form.config_list.length > 0) ? _c('span', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("备注：修改完成后请点击下方的保存，否则修改无效（删除配置及内容除外）")]) : _vm._e()])], 1)], 2)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1), _vm._v(" "), _c('preview', {
    ref: "preview",
    attrs: {
      "url": _vm.propsImg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40ff28a3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/cost/edit.vue
// module id = 1836
// module chunks = 2